import EA from '../helpers/init';

export default EA.Methods.headerSearchHandler = (id) => {
    const element = id || 'header-search';
    const $this = document.getElementById(element);
    if(!$this) return;
    const searchTrigger = $this.querySelector('.header-search-wrap');
    const searchInput = $this.querySelector('.search-input');
    const clearIcon = $this.querySelector('.clear-icon-wrap');
    const searchSuggestions = $this.querySelector('.header-search-suggestions-wrap-outer');
    const searchStatus = $this.querySelector('#searchStatus');
    const navLinks = document.querySelector('.header-main-nav-links');

    // Get suggestion items helper method
    const getSuggestionItems = function() {
        return Array.from(searchSuggestions.querySelectorAll('.header-search-suggestions-item button'));
    };

    // Update suggestions visibility helper method
    const updateSuggestionsVisibility = function(show) {
        if (show) {
            searchSuggestions.classList.add('show');

            const suggestionItems = getSuggestionItems();
            const count = suggestionItems.length;

            if (count > 0) {
                searchStatus.textContent = `${count} prijedloga za pretrživanje dostupno.`;
            } else {
                searchStatus.textContent = 'Nema prijedloga pretraživanja.';
            }
        } else {
            searchSuggestions.classList.remove('show');
            searchStatus.textContent = '';
        }
    };

    // Check for overlap of the search component over the navigation links
    const checkForOverlap = function() {
        const searchWrap = $this.querySelector('.header-search-wrap-outer');

        const navRect = navLinks.getBoundingClientRect();
        const searchRect = searchWrap.getBoundingClientRect();

        // Check for overlap
        const isOverlapping = (
            searchRect.left < navRect.right &&
            searchRect.right > navRect.left
        );

        if(isOverlapping) {
            navLinks.classList.add('faded');
        } else {
            navLinks.classList.remove('faded');
        }
    };

    // SearchTrigger click handler
    searchTrigger.addEventListener('click', () => {
        clearIcon.setAttribute('tabindex', 0);
        searchInput.setAttribute('tabindex', 0);    
        searchTrigger.setAttribute('aria-expanded', true);


        if(!$this.classList.contains('active')) {
            searchInput.focus();
        }

        $this.classList.add('active');
        checkForOverlap();
    });

    // Closing search when pressed escape / Open search when pressed enter
    searchTrigger.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            clearIcon.setAttribute('tabindex', -1);
            searchInput.setAttribute('tabindex', -1);   
            searchTrigger.setAttribute('aria-expanded', false);
            searchTrigger.focus();

            $this.classList.remove('active');
            navLinks.classList.remove('faded');

            updateSuggestionsVisibility(false);
            searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', -1));
        }

        if (event.key === 'Enter' || (event.key === ' ' || event.key === 'Spacebar')) {
            clearIcon.setAttribute('tabindex', 0);
            searchInput.setAttribute('tabindex', 0);    
            searchTrigger.setAttribute('aria-expanded', true);


            if(!$this.classList.contains('active')) {
                searchInput.focus();
            }

            $this.classList.add('active');
            checkForOverlap();
        }   
    });

    // Closing search when clicked outside
    document.addEventListener('mousedown', (event) => {
        if (!event.target.closest('.header-search')) {
            clearIcon.setAttribute('tabindex', -1);
            searchInput.setAttribute('tabindex', -1);
            searchTrigger.setAttribute('aria-expanded', false);

            if($this.classList.contains('active')) {
                searchTrigger.focus();
            }

            $this.classList.remove('active');
            navLinks.classList.remove('faded');

            updateSuggestionsVisibility(false);
            searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', -1));
        }
    });

    // Clear input handler
    clearIcon.addEventListener('click', (event) => {
        event.stopPropagation();

        updateSuggestionsVisibility(false);
        searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', -1));
        
        searchInput.value = '';
        searchInput.focus();
    });

    // Show suggestion dropdown on type with debounce
    let debounceTimerId;

    searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimerId);
        debounceTimerId = setTimeout(() => {
            if(searchInput.value === '') {
                updateSuggestionsVisibility(false);
                searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', -1));
            } else {
                updateSuggestionsVisibility(true);
                searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', 0));
            }
        }, 300);
    });

    // Focus into the suggestion list items on arrow down
    searchInput.addEventListener('keydown', (event) => {
        if(event.key === 'ArrowDown') {
            event.preventDefault();
            const suggestionItems = getSuggestionItems();
            if(!suggestionItems.length || !searchSuggestions.classList.contains('show')) return;

            suggestionItems[0].focus();
        }
    });

    // Arrow keys suggestion list items navigation handler
    searchSuggestions.addEventListener('keydown', (event) => {
        const suggestionItems = getSuggestionItems(); 
        const currentItemIndex = suggestionItems.indexOf(document.activeElement);

        if(currentItemIndex === -1) return;

        if(event.key === 'ArrowDown') {
            event.preventDefault();
            const nextItemIndex = Math.min(currentItemIndex + 1, suggestionItems.length - 1);
            suggestionItems[nextItemIndex].focus();
        }

        if(event.key === 'ArrowUp') {
            event.preventDefault();
            const prevItemIndex = Math.max(currentItemIndex - 1, 0);
            suggestionItems[prevItemIndex].focus();
        }

        if(event.key === 'Escape') {
            event.preventDefault();
            updateSuggestionsVisibility(false);
            searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', -1));

            searchInput.focus();
        }

        if(event.key === 'Enter' || (event.key === ' ' || event.key === 'Spacebar')) {
            event.preventDefault();
            const text = suggestionItems[currentItemIndex].textContent.trim();
            
            updateSuggestionsVisibility(false);
            searchSuggestions.querySelectorAll('.header-search-suggestions-item button').forEach(item => item.setAttribute('tabindex', -1));
            
            searchInput.value = text;
            searchInput.focus();
        }
    });

    // Search suggestion items click handler
    searchSuggestions.addEventListener('click', (event) => {
        const button = event.target.closest('.header-search-suggestions-item button');
        if(!button) return;

        const text = button.textContent.trim();
        searchInput.value = text;
        updateSuggestionsVisibility(false);
        searchInput.focus();
    });
};